export enum ShopPermissionType {
  notSet = 'NotSet',
  view = 'View',
  add = 'Add',
  edit = 'Edit',
  delete = 'Delete',
  primary = 'Primary'
}
